import React, { useEffect, useState } from "react";
import LessonAndAssingmentTab from "./LessonAndAssingmentTab";
import BackButton from "../BackButton/BackButton";
import { useLocation, useNavigate } from "react-router";
import Pagination from "@mui/material/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { CircularProgress, Grid } from "@mui/material";
import api from "../../api/api";
import { useAuth } from "../../features/auth/AuthContext";
import { updateGlobalState } from "../../state/global/slice";
import { syncAssignmentsSchoology, resetSyncAssignment } from '../../state/actions/syncAssignmentsSchoologyAction'
import LodingAnimation from "../LodingAnimation/LodingAnimation";
import "./AssignmentTab.css";
import SearchComponent from "../SearchComponent/SearchComponent";
import { search } from "../../assets/images/images";
import SortPopup from "../../pages/customSort/SortPopup";
import FloatingAIButton from "../FloatingAIButton/FloatingAIButton";
import { setDrawerState, setIsWebAllowed, setQueryMetaData } from "../../state/reducers/chatDrawerReducers";

const AssignmentTab = () => {
  const location = useLocation();

  const navigate = useNavigate();
  const { token } = useAuth();
  const itemsPerPage = 12;
  const [selLession, setSelLession] = useState(-1);
  const [totalPages, setTotalPages] = useState(0);
  const [assignmentSyncedId, setAssignmentSyncedId] = useState([]);
  const [allAssignmentId, setAllAssignmentId] = useState([]);
  const [allAssignment, setAllAssignment] = useState([]);
  const [getAssignmentCopy, setGetAssignmentCopy] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const onExpand = (i) => {
    setSelLession(selLession === i ? -1 : i);
  };
  const [lessonsDtls, setLessonsDtls] = useState();
  const inial_value = (currentPage - 1) * itemsPerPage;
  const syncAssignmentsWithSchoology = useSelector((state) => state.syncAssignmentsWithSchoology);
  const [searchBar, setSearchBar] = useState("");
  const [sortOption, setSortOption] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);

  const [deleteCourse, setdeleteCourse] = useState(false);
  const [loading, setLoading] = useState(false);
  const globalState = useSelector((state) => state.globalState);
  const dispatch = useDispatch();
  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };

  const [lessonlisting, setlessonlisting] = useState([]);

  const [selectedCourse, setSelectedCourse] = useState(null);
  const teacher_id =
    location.state?.teacher_id ??
    globalState.teacher_details?.data?.teacher_id ??
    "";

  useEffect(() => {
    if (syncAssignmentsWithSchoology.message) {
      toast.success(syncAssignmentsWithSchoology.message);
      dispatch(resetSyncAssignment());
    } else if (syncAssignmentsWithSchoology.error) {
      toast.error(syncAssignmentsWithSchoology.error);
      dispatch(resetSyncAssignment());
    }
  }, [syncAssignmentsWithSchoology])



  const getLessonDtails = async (page) => {
    setLoading(true);
    document.body.style.overflow = "auto";
    try {
      const response = await api.get(
        `/auth/get-assignment-by-teacher-course/`,
        {
          params: {
            page: page,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setLoading(false);

        setlessonlisting(response.data.data);
        const syncedAssignmentIds = response.data.all_assignments
          .filter(item => item.synced_with_schoology) // Filter assignments where synced_with_schoology is true
          .map(item => item.assignment_id); // Extract assignment IDs

        setAssignmentSyncedId(syncedAssignmentIds)

        const allAssignmentIds = response.data.all_assignments.map(item => item.assignment_id);
        setAllAssignmentId(allAssignmentIds)

        setAllAssignment(response.data.all_assignments)
        setGetAssignmentCopy(response.data.data)

        setTotalPages(
          response.data.count >= 12
            ? Math.ceil(response.data.count / itemsPerPage)
            : Math.floor(response.data.count / itemsPerPage)
        );

        setNextUrl(response.data.next); // Update next URL
        setPrevUrl(response.data.previous); // Update previous URL
      } else {
        setLoading(false);
        toast.error("Something went wrong.", {
          position: "top-center",
        });
      }
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    localStorage.removeItem("assignmentanalyticsdetails");
  }, []);

  useEffect(() => {
    return () => {
      dispatch(resetSyncAssignment());
    };
  }, []);

  useEffect(() => {
    return
  })
  useEffect(() => {
    getLessonDtails(currentPage);
  }, [currentPage]);
  const handlePageChange = (event, value) => {
    window.scrollTo(0, 0);
    setCurrentPage(value);
  };
  function formatDate(isoDate) {
    const date = new Date(isoDate);

    // Get individual date components
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" }); // 'Jan', 'Feb', 'Mar' etc.
    const year = date.getFullYear();

    // Get the suffix for the day
    let suffix = "th";
    if (day % 10 === 1 && day !== 11) {
      suffix = "st";
    } else if (day % 10 === 2 && day !== 12) {
      suffix = "nd";
    } else if (day % 10 === 3 && day !== 13) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month}, ${year}`;
  }


  const handleAllSync = (e) => {
    const isChecked = e.target.checked

    const res = {
      "assignment_ids": allAssignmentId,
      "toggle": isChecked
    }

    if (isChecked) {
      setAssignmentSyncedId(allAssignmentId)
    } else {
      setAssignmentSyncedId([])
    }

    dispatch(syncAssignmentsSchoology(res, token))

  }

  const handleSearch = (e) => {
    setSearchBar(e.target.value);
    if (e.target.value === '') {
      setlessonlisting(getAssignmentCopy)
    } else {
      const getCourseName = allAssignment.filter(course => course.name.toLowerCase().includes(e.target.value.toLowerCase()))

      setlessonlisting(getCourseName)
    }

  };

  const handleSortOptionChange = (newSortOption) => {
    setSortOption(newSortOption);
  };



  return (
    <>
      <div className="assignment-list-tab-section">
        <div className="assignment-list-section">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="view-course-Details-back-btn-folder mb-3">
                  <BackButton buttonName={"Back"} />
                  {/* <i className="fa-solid fa-arrow-left"></i>
                <h2>Back</h2> */}
                </div>
                {
                  !loading &&
                  <div className="search_header-container">
                    <SearchComponent
                      search={search}
                      searchPlaceholder="Search"
                      searchValue="search"
                      onchange={handleSearch}
                      name="searchOption"
                      value={searchBar}
                    />
                  </div>
                }
                {/* <div className="Sync-all-Schoology-container">
                  <h2 className="student-Active-Lessons" >Assignments</h2>
                  {
                    !loading &&
                    <div className="Sync-all-Schoology-" style={{display:'flex'}} >
                      <p>Sync all to Schoology</p>
                      <label class="switch" >
                        <input type="checkbox" onChange={handleAllSync} checked={allAssignmentId.length === assignmentSyncedId.length} />
                        <span class="slider round"></span>
                      </label>
                    </div>
                  }
                </div> */}
                <div className="assignment-list-wraper">
                  {loading || syncAssignmentsWithSchoology.isLoading ? (
                    <Grid
                      height={"50vh"}
                      xs={12}
                      container
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      <CircularProgress size={80} />
                    </Grid>
                  ) : lessonlisting.length > 0 ? (
                    lessonlisting.map((lesson, index) => (
                      <LessonAndAssingmentTab
                      key={index}
                        type="Assignment"
                        schoology='schoology'
                        titleHeader={inial_value + index}
                        title={lesson?.name}
                        Coursename={lesson?.course?.name}
                        start_date={formatDate(lesson.start_date)}
                        end_date={
                          lesson.end_date != null
                            ? formatDate(lesson.end_date)
                            : "-"
                        }
                        Progress_btn="Assignment Progress"
                        isAssignmentTab={false} // Add this line
                        course={lesson?.course}
                        lesson={lesson?.lesson}
                        assignment={lesson}
                        teacher_id={teacher_id}
                        assignmentSyncedId={assignmentSyncedId}
                        setAssignmentSyncedId={setAssignmentSyncedId}
                        index={index}
                        myRole={lesson.my_role}
                         student_enrollment_count={lesson.student_enrollment_count}
                        submission_count={lesson.submission_count}
                      />
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5">No Assignment found.</td>
                    </tr>
                  )}
                </div>
                <FloatingAIButton
                  onClick={() => {
                    dispatch(setDrawerState(!chatDrawerState.isOpen));
                    dispatch(setIsWebAllowed(true));
                    dispatch(setQueryMetaData(null));
                  }}
                />
              </div>
              {
                !loading && searchBar === '' && (
                  <Grid xs={12} container justifyContent={"center"}>
                    <Pagination
                      count={totalPages}
                      page={currentPage}
                      onChange={handlePageChange}
                      color="primary"
                      style={{margin:"20px"}}
                      hideNextButton={nextUrl === null || currentPage === totalPages} // Disable if no next URL and on the last page
                      hidePrevButton={prevUrl === null || currentPage === 1} // Hide if no previous URL and on the first page
                    />
                  </Grid>
                )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AssignmentTab;
